import { CommonModule } from "@angular/common";
import { Component, OnInit, forwardRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
  IonicModule,
  ModalController,
  NavController,
  NavParams,
} from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { SafeHtmlPipe } from "src/app/pipes/safe-html/safe-html";
import { UserProvider } from "src/app/services/user/user";
@Component({
  selector: "app-termo-uso",
  templateUrl: "./termo-uso.page.html",
  styleUrls: ["./termo-uso.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SafeHtmlPipe,
    TranslateModule,
    LoadingSpinnerComponent,
  ],
})
export class TermoUsoPage implements OnInit {
  modal = false;
  termo: string = "";
  idInstituicao: any;
  loaded = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public userProvider: UserProvider,
    public modalCtrl: ModalController
  ) {
    this.idInstituicao = this.navParams.get("idInstituicao");
    this.userProvider.getDados().then((result) => {
      this.idInstituicao = result?.instituicao ? result.instituicao.id : this.idInstituicao;

      this.userProvider.getTermoUso(this.idInstituicao).subscribe({
        next: (data) => {
          this.termo = data;
          this.modal = this.navParams.get("modal");

          setTimeout(() => {
            this.loaded = true;
          }, 1000);
        },
        error: (err) => {
          console.error("Erro:", err);
          this.loaded = true;
        },
      });
    });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
